import fetch from 'utils/fetch';

export const REQUEST_PESTS = 'REQUEST_PESTS';
export const RECEIVE_PESTS = 'RECEIVE_PESTS';

function requestPests() {
  return {
    type: REQUEST_PESTS,
  };
}

function receivePests(pests) {
  return {
    type: RECEIVE_PESTS,
    payload: {
      pests,
    },
  };
}

export function fetchPests() {
  return dispatch => {
    dispatch(requestPests());
    fetch('/pests.json')
      .then(res => res.json())
      .then(pests => dispatch(receivePests(pests)));
  };
}



// WEBPACK FOOTER //
// ./src/modules/catalog/actions/pest.js